import React from "react";

import SourceCallSingCellContent from "../components/SourceCallSingCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function sourceCallSing({ width, onResize }: Column.Options) {
	return base(
		ColumnId.SourceCallSing,
		(item) => <SourceCallSingCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default sourceCallSing;
